import { createRouter, createWebHistory } from "vue-router";
import AuthView from "@/views/AuthView.vue";
import IndexProfileView from "@/views/pages/profile/ProfileView.vue";
import DashboardView from "@/views/pages/DashboardViewOld.vue";
import OrderListView from "@/views/pages/OrderListView.vue";
import AttendanceView from "@/views/pages/attendance/AttendanceView.vue";
import AttendanceDetailView from "@/views/pages/attendance/AttendanceDetailView.vue";
import EmployeeView from "@/views/pages/employee/EmployeeView.vue";
import AddEditEmployee from "@/views/pages/employee/AddEditEmployee.vue";
import CustomerView from "@/views/pages/customer/CustomerView.vue";
import AddEditCustomer from "@/views/pages/customer/AddEditCustomer.vue";
import OutletView from "@/views/pages/outlet/OutletView.vue";
import AddEditOutlet from "@/views/pages/outlet/AddEditOutlet.vue";
import ProductManagementView from "@/views/pages/product/ProductManagementView.vue";
import AddEditProduct from "@/views/pages/product/AddEditProduct.vue";
import InventoryView from "@/views/pages/inventory/InventoryView.vue";
import AddEditInventory from "@/views/pages/inventory/AddEditInventory.vue";
import AttributeView from "@/views/pages/attribute/AttributeView.vue";
import AttributeListView from "@/views/pages/attribute/AttributeListView.vue";
import CategoryView from "@/views/pages/category/CategoryView.vue";
import CategoryItemView from "@/views/pages/category-item/CategoryItemView.vue";
import ItemView from "@/views/pages/item/ItemView.vue";
import UnitView from "@/views/pages/unit/UnitView.vue";
import MarketingView from "@/views/pages/marketing/MarketingView.vue";
import SettingView from "@/views/pages/setting/SettingView.vue";
import TransactionView from "@/views/pages/transaction/TransactionView.vue";
import TransactionTypeView from "@/views/pages/transaction-type/TransactionTypeView.vue";
import CheckoutView from "@/views/pages/CheckoutView.vue";
import TableView from "@/views/pages/table/TableView.vue";
import KitchenDivisionView from "@/views/pages/kitchen-division/KitchenDivisionView.vue";
import UserView from "@/views/pages/user/UserView.vue";
import AddEditUser from "@/views/pages/user/AddEditUser.vue";
import NewTransactionView from "@/views/pages/new-transaction/NewTransactionView.vue";

import { requireAuth } from '@/middleware/auth';
import ChooseTableView from "@/views/pages/new-transaction/choose-table/ChooseTableView.vue";
import OrderView from "@/views/pages/new-transaction/order/OrderView.vue";
import PembayaranView from "@/views/pages/new-transaction/payment/PaymentView.vue";
import NewDashboardView from "@/views/pages/DashboardView.vue";
import CashRegisterView from "@/views/pages/cash-register/CashRegisterView.vue";
import CashRegisterDetailView from "@/views/pages/cash-register/CashRegisterDetailView.vue";
import DetailTransactionView from "@/views/pages/transaction/DetailView.vue";
import BillPrint from "@/components/print/receipt/BillPrint.vue";
import CheckerPrint from "@/components/print/checker/CheckerPrint.vue";
import BillOfMaterialSetup from "@/views/pages/item/BillOfMaterialSetup.vue";
import StockMovement from "@/views/pages/item/StockMovement.vue";

import AllSalesOrders from "@/views/pages/report/AllSalesOrders.vue";
import DailySalesOrders from "@/views/pages/report/DailySalesOrders.vue";
import PettyCashView from "@/views/pages/petty-cash/PettyCashView.vue";

import GlobalDiscountView from "@/views/pages/global-discount/GlobalDiscountView.vue";

import RoleView from "@/views/pages/role/RoleView.vue";
import AddEditRole from "@/views/pages/role/AddEditRole.vue";
import CreditView from "@/views/pages/credit/CreditView.vue";
import ActivityLogsView from "@/views/pages/activity-log/ActivityLogsView.vue";

import StockOpnameView from "@/views/pages/stock-opname/StockOpnameView.vue";
import AddStockOpname from "@/views/pages/stock-opname/AddStockOpname.vue";
import EditStockOpname from "@/views/pages/stock-opname/EditStockOpname.vue";
import InboundItemsFormView from "@/views/pages/inbound-items-form/InboundItemsFormView.vue";
import AddInboundItemsForm from "@/views/pages/inbound-items-form/AddInboundItemsForm.vue";
import EditInboundItemsForm from "@/views/pages/inbound-items-form/EditInboundItemsForm.vue";
import OutboundItemsFormView from "@/views/pages/outbound-items-form/OutboundItemsFormView.vue";
import AddOutboundItemsForm from "@/views/pages/outbound-items-form/AddOutboundItemsForm.vue";
import EditOutboundItemsForm from "@/views/pages/outbound-items-form/EditOutboundItemsForm.vue";
import ViewStockOpname from "@/views/pages/stock-opname/ViewStockOpname.vue";

// import { requireSuperadmin } from '@/middleware/role';

const routes = 
[
    { path:'/', component: AuthView },
    { path:'/profil', component: IndexProfileView, beforeEnter: requireAuth },
    {
        path:'/dashboard',
        name:'Dashboard',
        component: NewDashboardView,
        beforeEnter: requireAuth
    },
    {
        path:'/dashboard/transaksi/:id',
        name:'EditTransaction',
        props: true,
        component: DashboardView,
        beforeEnter: requireAuth
    },
    {
        path:'/order_list',
        component: OrderListView,
        beforeEnter: requireAuth
    },
    {
        path:'/checkout/transaksi/:id',
        name:'CheckoutView',
        props: true,
        component: CheckoutView,
        beforeEnter: requireAuth
    },
    {
        path:'/absensi',
        component: AttendanceView,
        beforeEnter: requireAuth
    },
    {
        path:'/absensi/detail',
        component: AttendanceDetailView,
        beforeEnter: requireAuth
    },
    {
        path:'/pegawai',
        name: 'EmployeeView',
        component: EmployeeView,
        beforeEnter: requireAuth
    },
    { path:'/pegawai/tambah-pegawai', name: 'AddEmployee', component: AddEditEmployee, beforeEnter: requireAuth },
    { path:'/pegawai/edit-pegawai/:id', name: 'EditEmployee', component: AddEditEmployee, props:true, beforeEnter: requireAuth },
    { path:'/pelanggan', name: 'CustomerView', component: CustomerView, beforeEnter: requireAuth },
    { path:'/pelanggan/tambah-pelanggan', name: 'AddCustomer', component: AddEditCustomer, beforeEnter: requireAuth },
    { path:'/pelanggan/edit-pelanggan/:id', name: 'EditCustomer', component: AddEditCustomer, props:true, beforeEnter: requireAuth },
    { path:'/outlet', component: OutletView, beforeEnter: requireAuth },
    { path:'/outlet/tambah-outlet', name:'AddOutlet', component: AddEditOutlet, beforeEnter: requireAuth },
    { path:'/outlet/edit-outlet/:id', name:'EditOutlet', component: AddEditOutlet, props:true, beforeEnter: requireAuth },
    { path:'/inventori', component: InventoryView, beforeEnter: requireAuth },
    { path:'/inventori/tambah-inventori', name:'AddInventory', component: AddEditInventory, beforeEnter: requireAuth },
    { path:'/inventori/edit-inventori/:id', name:'EditInventory', component: AddEditInventory, props:true,  beforeEnter: requireAuth },
    { path:'/atribut', component: AttributeView, beforeEnter: requireAuth },
    { path:'/atribut-list', component: AttributeListView, beforeEnter: requireAuth },
    { path:'/kategori', component: CategoryView, beforeEnter: requireAuth },
    { path:'/kategori-item', component: CategoryItemView, beforeEnter: requireAuth },
    { path:'/item', component: ItemView, beforeEnter: requireAuth },
    { path:'/bill-of-material-setup/:id', name: 'BillOfMaterialSetup', component: BillOfMaterialSetup, beforeEnter: requireAuth },
    { path:'/stock-movement/:id', name: 'StockMovement', component: StockMovement, beforeEnter: requireAuth },
    { path:'/unit', component: UnitView, beforeEnter: requireAuth },
    { path:'/user', component: UserView, beforeEnter: requireAuth },
    { path:'/user/tambah-user', name:'AddUser', component: AddEditUser, beforeEnter: requireAuth },
    { path:'/user/edit-user/:id', name:'EditUser', component: AddEditUser, props:true, beforeEnter: requireAuth },
    { path:'/marketing', component: MarketingView, beforeEnter: requireAuth },
    { path:'/table', component: TableView, beforeEnter: requireAuth },
    { path:'/transaction-type', component: TransactionTypeView, beforeEnter: requireAuth },
    { path:'/kitchen-division', component: KitchenDivisionView, beforeEnter: requireAuth },
    { path:'/kelola-produk', name: 'ProductManagementView', component: ProductManagementView, beforeEnter: requireAuth },
    { path:'/kelola-produk/tambah-produk', name: 'AddProduct', component: AddEditProduct, beforeEnter: requireAuth },
    { path:'/kelola-produk/edit-produk/:id', name: 'EditProduct', component: AddEditProduct, props:true, beforeEnter: requireAuth },
    { path:'/riwayat-transaksi', component: TransactionView, beforeEnter: requireAuth },
    { path:'/detail-transaksi', component: DetailTransactionView, beforeEnter: requireAuth },
    { path:'/pengaturan', component: SettingView, beforeEnter: requireAuth },

    { path:'/new-transaction', name: 'newTransaction', component: NewTransactionView, beforeEnter: requireAuth },
    { path:'/choose-table', name: 'chooseTable', component: ChooseTableView, props: route => ({ choose: route.query.choose }), beforeEnter: requireAuth },
    { path:'/order', name: 'order', component: OrderView, beforeEnter: requireAuth },

    { path:'/payment', name: 'payment', component: PembayaranView, beforeEnter: requireAuth },
    { path:'/hutang', name: 'hutang', component: CreditView, beforeEnter: requireAuth },
    { path:'/cash-register', name: 'cashRegister', component: CashRegisterView, beforeEnter: requireAuth },
    { path:'/cash-register/:id', name: 'cashRegisterDetail', component: CashRegisterDetailView, props: true, beforeEnter: requireAuth },
    { path:'/bill', name: 'bill', component: BillPrint, beforeEnter: requireAuth },
    { path:'/checker', name: 'checker', component: CheckerPrint, beforeEnter: requireAuth },

    { path:'/report/all-sales-order', component: AllSalesOrders, beforeEnter: requireAuth },
    { path:'/report/daily-sales-order', component: DailySalesOrders, beforeEnter: requireAuth },

    { path:'/global-discount', component: GlobalDiscountView, beforeEnter: requireAuth },
    { path:'/petty-cash', component: PettyCashView, beforeEnter: requireAuth },

    { path:'/role', component: RoleView, beforeEnter: requireAuth },
    { path:'/role/tambah-role', name:'AddRole', component: AddEditRole, beforeEnter: requireAuth },
    { path:'/role/edit-role/:id', name:'EditRole', component: AddEditRole, props:true, beforeEnter: requireAuth },
    { path:'/activity-log', component: ActivityLogsView, beforeEnter: requireAuth },

    { path:'/stock-opname', component: StockOpnameView, beforeEnter: requireAuth },
    { path:'/stock-opname/new', component: AddStockOpname, beforeEnter: requireAuth },
    { path:'/stock-opname/edit/:id', component: EditStockOpname, beforeEnter: requireAuth },
    { path:'/stock-opname/view/:id', component: ViewStockOpname, beforeEnter: requireAuth },

    { path:'/inbound-items-form', component: InboundItemsFormView, beforeEnter: requireAuth },
    { path:'/inbound-items-form/new', component: AddInboundItemsForm, beforeEnter: requireAuth },
    { path:'/inbound-items-form/edit/:id', component: EditInboundItemsForm, beforeEnter: requireAuth },
    
    { path:'/outbound-items-form', component: OutboundItemsFormView, beforeEnter: requireAuth },
    { path:'/outbound-items-form/new', component: AddOutboundItemsForm, beforeEnter: requireAuth },
    { path:'/outbound-items-form/edit/:id', component: EditOutboundItemsForm, beforeEnter: requireAuth },
];

const router = createRouter({
    history: createWebHistory(),
    routes
});

export default router;